import { RefObject } from 'react'
import { ELEMENT_IDS } from '@/config/html-attributes.config'

/**
 * Scroll to an absolute value or a selector.
 * @param {number} top X value to scroll.
 * @param {number} left Y Value to scroll.
 */
export const safeScroll = (top = 0, left = 0): void => {
  if (typeof window !== 'undefined' && window.scrollTo) {
    try {
      window.scrollTo({
        top,
        left,
        behavior: 'smooth',
      })
    } catch {
      window.scrollTo(left, top)
    }
  }
}

/**
 * Scrolls the window to the top of the provided `ref`
 * @param ref - A {@link React.MutableRefObject} to scroll to
 * @param mobile - if true, reduces scroll to account for mobile headers
 */
export const scrollToTopOfRef = (
  ref: RefObject<HTMLElement | null>,
  mobile: boolean,
): void => {
  if (ref && ref.current) {
    let scrollTo = (ref.current.getBoundingClientRect().top || 0) + window.scrollY
    if (mobile) {
      const padding = 5
      const mobileHeaderHeight = (document.getElementById(ELEMENT_IDS.STICKY_HEADER)?.offsetHeight || 80) + padding
      scrollTo -= mobileHeaderHeight
    }
    safeScroll(scrollTo, undefined)
  }
}
